import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'positions': [],
  'positionSelected': null,
  'loading': false,
};

export const wtsPositions = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WTS_POSITIONS]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_POSITIONS]: (state, action) => ({
      ...state,
      'loading': false,
      'positions': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_POSITIONS_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'positions': [],
    }),
    [ActionTypes.UPDATING_WTS_POSITIONS]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_WTS_POSITIONS]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_WTS_POSITIONS_FAILED]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CHANGE_WTS_POSITION_SELECTED]: (state, action) => ({
      ...state,
      'loading': false,
      'positionSelected': action.payload,
    }),
  })(state, action);
};
